import React from 'react';
import Layout from '@/components/Layout/Layout';
import HeroSection from '@/components/HomePage/HeroSection';
import MathCalculatorsSection from '@/components/HomePage/MathCalculatorsSection';
import CalculatorCategoriesContainer from '@/components/HomePage/CalculatorCategoriesContainer';
import BenefitsSection from '@/components/HomePage/BenefitsSection';
import { Link } from "react-router-dom";

const Index = () => {
  return (
    <Layout>
      <HeroSection />
      
      {/* Featured Calculators - Adding this section to ensure critical calculators are accessible */}
      <div className="bg-blue-50 py-8">
        <div className="container mx-auto px-4">
          <h2 className="text-2xl font-bold mb-6 text-center">Featured Calculators</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            <Link 
              to="/special/auto" 
              className="p-4 bg-white rounded-lg shadow-sm border border-gray-200 hover:shadow-md transition-shadow"
            >
              <span className="text-2xl">🚗</span>
              <h3 className="font-semibold mt-2">Auto Loan Calculator</h3>
              <p className="text-sm text-gray-600">Calculate car payments and total costs</p>
            </Link>
            
            <Link 
              to="/special/mortgage" 
              className="p-4 bg-white rounded-lg shadow-sm border border-gray-200 hover:shadow-md transition-shadow"
            >
              <span className="text-2xl">🏠</span>
              <h3 className="font-semibold mt-2">Mortgage Calculator</h3>
              <p className="text-sm text-gray-600">Calculate mortgage payments</p>
            </Link>
            
            <Link 
              to="/special/bmi" 
              className="p-4 bg-white rounded-lg shadow-sm border border-gray-200 hover:shadow-md transition-shadow"
            >
              <span className="text-2xl">⚖️</span>
              <h3 className="font-semibold mt-2">BMI Calculator</h3>
              <p className="text-sm text-gray-600">Calculate your body mass index</p>
            </Link>
            
            <Link 
              to="/special/bmr" 
              className="p-4 bg-white rounded-lg shadow-sm border border-gray-200 hover:shadow-md transition-shadow"
            >
              <span className="text-2xl">🔥</span>
              <h3 className="font-semibold mt-2">BMR Calculator</h3>
              <p className="text-sm text-gray-600">Calculate your metabolic rate</p>
            </Link>
            
            <Link 
              to="/special/compound-interest" 
              className="p-4 bg-white rounded-lg shadow-sm border border-gray-200 hover:shadow-md transition-shadow"
            >
              <span className="text-2xl">📈</span>
              <h3 className="font-semibold mt-2">Compound Interest</h3>
              <p className="text-sm text-gray-600">Calculate compound interest growth</p>
            </Link>
            
            <Link 
              to="/special/roi" 
              className="p-4 bg-white rounded-lg shadow-sm border border-gray-200 hover:shadow-md transition-shadow"
            >
              <span className="text-2xl">💹</span>
              <h3 className="font-semibold mt-2">ROI Calculator</h3>
              <p className="text-sm text-gray-600">Calculate return on investment</p>
            </Link>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mt-4">
            <Link 
              to="/special/anova" 
              className="p-4 bg-white rounded-lg shadow-sm border border-gray-200 hover:shadow-md transition-shadow"
            >
              <span className="text-2xl">📊</span>
              <h3 className="font-semibold mt-2">ANOVA Calculator</h3>
              <p className="text-sm text-gray-600">Analysis of variance calculator</p>
            </Link>
            
            <Link 
              to="/converters/area" 
              className="p-4 bg-white rounded-lg shadow-sm border border-gray-200 hover:shadow-md transition-shadow"
            >
              <span className="text-2xl">📐</span>
              <h3 className="font-semibold mt-2">Area Converter</h3>
              <p className="text-sm text-gray-600">Convert area units</p>
            </Link>
            
            <Link 
              to="/special/gfr" 
              className="p-4 bg-white rounded-lg shadow-sm border border-gray-200 hover:shadow-md transition-shadow"
            >
              <span className="text-2xl">🫘</span>
              <h3 className="font-semibold mt-2">GFR Calculator</h3>
              <p className="text-sm text-gray-600">Calculate kidney function</p>
            </Link>
            
            <Link 
              to="/special/gpa" 
              className="p-4 bg-white rounded-lg shadow-sm border border-gray-200 hover:shadow-md transition-shadow"
            >
              <span className="text-2xl">🎓</span>
              <h3 className="font-semibold mt-2">GPA Calculator</h3>
              <p className="text-sm text-gray-600">Calculate grade point average</p>
            </Link>
          </div>
        </div>
      </div>
      
      <div className="container mx-auto px-4">
        <MathCalculatorsSection />
        <CalculatorCategoriesContainer />
      </div>
    </Layout>
  );
};

export default Index;
